import React, { useState } from 'react';

import AddIcon from '@mui/icons-material/Add';
import {
    Button,
    Container as MuiContainer,
    Grid,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { HeaderContainer, TitleIcon, TabsSystem } from 'common/components';

import IcoTemplates from 'resources/icoTemplates.svg?react';

import attachments from '../attachments';
import createAttachmentModal from '../createAttachmentModal';
import * as createAttachmentModalActions from '../createAttachmentModal/actions';
import createTemplateModal from '../createTemplateModal';
import * as createTemplateModalActions from '../createTemplateModal/actions';
import templates from '../templates';

const getTabs = (t) => [
    {
        id: 'templates',
        label: t('Template', { count: 2 }),
        content: <templates.Container />,
    },
    {
        id: 'attachments',
        label: t('Attachment', { count: 2 }),
        content: <attachments.Container />,
    },
];

const Container = ({ handleClickCreate, handleClickCreateAttachment }) => {
    const { t } = useTranslation();
    const [currentTabId, setCurrentTabId] = useState('templates');

    return (
        <MuiContainer maxWidth={false}>
            <HeaderContainer>
                <Grid size="grow">
                    <TitleIcon
                        icon={<IcoTemplates />}
                        title={t('Document', { count: 2 })}
                    />
                </Grid>
                <Grid>
                    <Button
                        onClick={() => {
                            if (currentTabId === 'templates')
                                handleClickCreate();
                            else handleClickCreateAttachment();
                        }}
                        startIcon={<AddIcon />}
                        type="button"
                    >
                        {t('Add')}
                    </Button>
                </Grid>
            </HeaderContainer>
            <TabsSystem
                baseUrl="documents"
                tabs={getTabs(t)}
                setCurrentTabId={setCurrentTabId}
            />
            <createTemplateModal.Container />
            <createAttachmentModal.Container />
        </MuiContainer>
    );
};
Container.propTypes = {
    handleClickCreate: PropTypes.func,
    handleClickCreateAttachment: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => ({
    handleClickCreate: () =>
        dispatch(createTemplateModalActions.prepareCreate()),
    handleClickCreateAttachment: () =>
        dispatch(createAttachmentModalActions.prepareCreate()),
});

export default connect(null, mapDispatchToProps)(Container);
